<div class="step-generating">
  <div class="generating-content">
    @if (isGenerating()) {
      <div class="spinner"></div>
      <p class="generating-message">
        Generating {{ formData().postCount === 1 ? 'your post' : formData().postCount + ' posts' }}
        with AI...
      </p>
      <p class="generating-subtext">Please wait while we prepare your content.</p>
    } @else if (generateError()) {
      <p class="generating-message generating-message--error">{{ generateError() }}</p>
      <div class="error-actions">
        <button type="button" class="btn btn--ghost" (click)="backToPrompt()">Edit prompt</button>
        <button
          type="button"
          class="btn btn--primary"
          [disabled]="!service.hasAiImageCredits()"
          (click)="retry()"
        >
          Try again
        </button>
      </div>
    }
  </div>
</div>
